import React, { useEffect, useState } from 'react';
import { getAuthStatus } from '../../localstorage';
import { useNavigate } from 'react-router-dom';

export default function Portfolio() {
    const portfolioStyles = {
        backgroundColor: '#f9f9f9',
        padding: '20px',
        borderRadius: '5px',
    };

    const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate(); // Move useNavigate here

  useEffect(() => {
    const checkAuthentication = () => {
      const isAuthenticated = getAuthStatus('_id');
      if (!isAuthenticated) {
        navigate("/login");
      } else {
        setAuthenticated(true);
      }
    };

    checkAuthentication();
  }, [navigate]);


    return (
        <div>
            <h1>Personal Portfolio</h1>
            <div style={portfolioStyles}>
                <h2>My Projects</h2>
                <ul>
                    <li>Project 1</li>
                    <li>Project 2</li>
                    
                </ul>
            </div>
            <div>
                <h2>Code Snippet (HTML):</h2>
                <pre>{`
                <div class="portfolioStyles">
                    <h2>My Projects</h2>
                    <ul>
                        <li>Project 1</li>
                        <li>Project 2</li>
                        <!-- Add more projects as needed -->
                    </ul>
                </div>
                `}</pre>
            </div>
            <div>
                <h2>Code Snippet (CSS):</h2>
                <pre>{`
                  portfolioStyles {
                    background-color: #f9f9f9;
                    padding: 20px;
                    border-radius: 5px;
                }
                `}</pre>
            </div>
        </div>
    );
}
